export default {
  disponibileBio: 'Disponibile Bio',
  certificatoBio: 'Certificato Bio',
  'Certificato Bio': 'Certificato Bio',
  'Disponibile Bio': 'Disponibile Bio',
  vino: 'Vin',
  birra: 'Bière',
  panificati: 'Produits de boulangerie',
  agricoltura: 'Agriculture',
  nutraceutica: 'Nutraceutique',
  altriProdotti: 'Autres produits de la même famille',
  structuredTitle: 'Augmentez l’efficacité de {title} avec :',
  prefix: {
    vino: 'Vins',
  },
  adattoPer: 'Adapté pour',
  stili: 'Styles',
  disponibilitaProdotto: 'Disponible en formats: ',
}
